import {
  CartesianGrid,
  ScatterChart as RechartsScatterChart,
  ReferenceLine,
  ResponsiveContainer,
  Scatter,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { useChartColors } from "./chart-theme";

export interface ScatterChartProps {
  /** Chart data array */
  data: Array<Record<string, unknown>>;
  /** Key for X-axis values */
  xKey: string;
  /** Key for Y-axis values */
  yKey: string;
  /** Chart height in pixels */
  height?: number;
  /** Optional reference Y value (e.g., threshold) */
  referenceY?: number;
}

/**
 * Themed Recharts ScatterChart component.
 * Supports optional reference line (e.g., for thresholds).
 */
export function ScatterChart({ data, xKey, yKey, height = 300, referenceY }: ScatterChartProps) {
  const colors = useChartColors();

  return (
    <ResponsiveContainer width="100%" height={height}>
      <RechartsScatterChart margin={{ top: 5, right: 20, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" stroke={colors.grid} />
        <XAxis
          type="number"
          dataKey={xKey}
          stroke={colors.axis}
          tick={{ fill: colors.text, fontSize: 12 }}
        />
        <YAxis
          type="number"
          dataKey={yKey}
          stroke={colors.axis}
          tick={{ fill: colors.text, fontSize: 12 }}
        />
        <Tooltip
          contentStyle={{
            backgroundColor: colors.surface,
            border: `1px solid ${colors.grid}`,
            borderRadius: "8px",
            color: colors.text,
          }}
          cursor={{ strokeDasharray: "3 3" }}
        />
        {referenceY !== undefined && (
          <ReferenceLine
            y={referenceY}
            stroke={colors.negative}
            strokeDasharray="5 5"
            strokeWidth={2}
          />
        )}
        <Scatter data={data} fill={colors.primary} fillOpacity={0.7} shape="circle" />
      </RechartsScatterChart>
    </ResponsiveContainer>
  );
}
